export const CAMPUS_COOKIE = "campus";
export const PLATFORM_SESSION_COOKIE = "platsessionid";
